module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAKlBMVEUAAAAqrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW8qrW9zKzQTAAAADXRSTlMA8a0ZV7YnxGYoJRjDmP+lFQAAAGxJREFUKM9jYGBYJHsXCi5qMQABG5APF0kACjBdNWCAAuZYBSDJeJkBDmwFgATvBSDBfvfuAQgbIVCAJAABowIQgbtIAEMAjxksDmgCvVdwCMAjigOsZa8AOCo3oEYlJ3JkTwCJJyGSgxoDAwArIW/exz+1mAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon_mobile.png
// module id = BfVd
// module chunks = 1